import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";
import Select from "react-select"; // Importing react-select for searchable dropdown
import { getRequest } from "services/api";
import { buildQueryString } from "utils/queryHelpers";

const CreatePage = ({ initialData, onSuccess, onError }) => {
  const API_URL = "/customer";

  // State untuk menyimpan form data. Jika initialData tersedia, isi form untuk update
  const [formData, setFormData] = useState({
    name: "",
    nationality: "", // Changed 'address' to 'nationality'
    email: "",
    phone: "",
    mark: "",
  });

  const isUpdateMode = !!initialData; // Cek apakah ini update mode atau create mode

  // API hook untuk create dan update
  const { createData: createProduct, loading: creatingProduct } = useCreateData(
    API_URL,
    "customers"
  );
  const { updateData: updateProduct, loading: updatingProduct } = useUpdateData(
    `${API_URL}/${initialData?.id}`,
    "customers"
  );

  // Gunakan hook untuk menangani perubahan form
  const handleChange = useFormChangeHandler(setFormData);

  // Use hook for handling form submission
  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updateProduct : createProduct,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
    };

    handleSubmit(payload, e);
  };

  useEffect(() => {
    // If initialData is provided (for update), fill the form with existing data
    if (initialData) {
      setFormData({
        ...initialData,
      }); // Adjust based on the structure of initialData
    }
  }, [initialData]);

  // nationalityities or Countries for the searchable select dropdown
  const nationalityityOptions = [
    { value: "American", label: "American" },
    { value: "Canadian", label: "Canadian" },
    { value: "British", label: "British" },
    { value: "Australian", label: "Australian" },
    { value: "German", label: "German" },
    { value: "French", label: "French" },
    { value: "Italian", label: "Italian" },
    { value: "Japanese", label: "Japanese" },
    { value: "Indian", label: "Indian" },
    { value: "Brazilian", label: "Brazilian" },
    // Add more nationalityities as needed
  ];

  return (
    <form
      onSubmit={(e) => handleBeforeSubmit(e)}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="invoice_number"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Name :
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.name && "is-invalid"
              )}
              id="name"
              placeholder="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.name && (
              <div className="invalid-feedback">{formError.name}</div>
            )}
          </div>
        </div>

        {/* nationality Field with Searchable Dropdown */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="nationality"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Nationality/Hotel :
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.nationalityity && "is-invalid"
              )}
              id="nationalityity"
              placeholder="Nationality/Hotel"
              name="nationality"
              value={formData.nationality}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {/* <Select
              id="nationality"
              name="nationality" // Keep 'nationality' as the field name
              options={nationalityityOptions}
              value={
                formData.nationality
                  ? { value: formData.nationality, label: formData.nationality }
                  : null
              }
              onChange={(selectedOption) =>
                handleChange({
                  target: { name: "nationality", value: selectedOption?.value },
                })
              }
              isSearchable // Makes the dropdown searchable
              placeholder="Select nationalityity"
              isDisabled={isSubmitting}
              className={clsx(formError?.nationality && "is-invalid")}
            /> */}
            {formError?.nationality && (
              <div className="invalid-feedback">{formError.nationality}</div>
            )}
          </div>
        </div>

        <div className="row mb-3 align-items-center">
          <label
            htmlFor="invoice_number"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Email :
          </label>
          <div className="col-sm-8">
            <input
              type="email"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.email && "is-invalid"
              )}
              id="email"
              placeholder="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.email && (
              <div className="invalid-feedback">{formError.email}</div>
            )}
          </div>
        </div>

        <div className="row mb-3 align-items-center">
          <label
            htmlFor="invoice_number"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Phone :
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.phone && "is-invalid"
              )}
              id="phone"
              placeholder="Phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.phone && (
              <div className="invalid-feedback">{formError.phone}</div>
            )}
          </div>
        </div>
        {/* mark */}
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="mark"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Mark :
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.phone && "is-invalid"
              )}
              id="mark"
              placeholder="Mark"
              name="mark"
              value={formData.mark}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.mark && (
              <div className="invalid-feedback">{formError.mark}</div>
            )}
          </div>
        </div>
      </div>

      <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          {isUpdateMode ? "Update Customer" : "Create Customer"}
        </button>
      </div>
    </form>
  );
};

export default CreatePage;
